import { catchError, mergeMap, withLatestFrom } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { EMPTY, Observable } from 'rxjs';
import { Actions } from 'src/core/state/user';
import { EpicDeps } from 'src/core/engine';

import { cartItems } from '../utils/stateObservables';
import { fetchMineCartId } from '../utils/fetchMineCartId';

/**
 * Listen for the user signing in
 *
 * When that happens, attempt to refresh the cart
 *
 * @param action$
 * @param state$
 * @param deps
 */
export function userSignedInReaction(action$: Observable<any>, state$: Observable<any>, deps: EpicDeps) {
    return action$.pipe(
        ofType<Actions>('User.SignInSuccess'),
        withLatestFrom(cartItems(state$)),
        mergeMap(([, items]) => {
            /**
             * If guest cart has 0 items, always refresh from the user
             */
            if (items.length === 0) {
                return fetchMineCartId(deps).pipe(
                    mergeMap(() => {
                        debugger;
                        return EMPTY;
                    }),
                    catchError((e) => {
                        console.error(e);
                        debugger;
                        return EMPTY;
                    }),
                );
            }
            return EMPTY;
        }),
    );
}
